const promiseMiddleware = () => next => action => {
  if (!action || !action.fetchConfig) {
    return next(action);
  }
  return new Promise(resolve => next({
    ...action,
    successCb: resolve,
  }));
};

export default promiseMiddleware;
